import { render, staticRenderFns } from "./mintingDialog.vue?vue&type=template&id=54320f50&scoped=true"
import script from "./mintingDialog.vue?vue&type=script&lang=js"
export * from "./mintingDialog.vue?vue&type=script&lang=js"
import style0 from "./mintingDialog.vue?vue&type=style&index=0&id=54320f50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_yhenekn6hnf4pbbtdhpnebbsqm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54320f50",
  null
  
)

export default component.exports